import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { CustomTextFieldProps } from "./CustomTextField.props";

const CustomTextField: React.FC<CustomTextFieldProps> = ({
    name,
    label,
    type,
    variant = "outlined",
    required = false,
    className,
    isDisabled = false,
    rows = undefined,
    startAdornment,
    endAdornment,
    hasFocus = false,
    handleInputChange,
    fullWidth,
}) => {
    const methods = useFormContext();
    const [previousValue, setPreviousValue] = useState<string>("");

    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                <TextField
                    fullWidth={fullWidth ? fullWidth : false}
                    required={required}
                    type={type ? type : "text"}
                    variant={variant}
                    size="small"
                    onChange={(event: any) => {
                        onChange(event.target.value);
                        if (
                            handleInputChange &&
                            (hasFocus ? previousValue !== event.target.value.trim() : true)
                        ) {
                            handleInputChange(event.target.value.trim());
                        }
                        setPreviousValue("");
                    }}
                    onBlur={(event: any) => {
                        onChange(event.target.value.trim());
                        if (
                            handleInputChange &&
                            (hasFocus ? previousValue !== event.target.value.trim() : true)
                        ) {
                            handleInputChange(event.target.value.trim());
                        }
                        setPreviousValue("");
                    }}
                    value={value || ""}
                    label={label}
                    error={!!error}
                    inputRef={ref}
                    helperText={error ? error.message : null}
                    className={className}
                    disabled={!!isDisabled}
                    rows={rows}
                    multiline={!!rows}
                    autoComplete="off"
                    onFocus={(event: any) => {
                        if (hasFocus) {
                            setPreviousValue(event.target.value);
                        }
                    }}
                    InputProps={{
                        startAdornment: startAdornment,
                        endAdornment: endAdornment,
                    }}
                />
            )
            }
        />
    );
};

export default CustomTextField;
